import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
  }),
  withCredentials: true
};

export type DocumentMigrationPhase = 'Copy' | 'Verify' | 'Reclaim';

export interface IDocumentMigrationJob {
  id: number;
  phase: string;
  status: string;
  startedUtc: string;
  completedUtc: string;
  totalCount: number;
  processedCount: number;
  succeededCount: number;
  failedCount: number;
  skippedCount: number;
  currentSourceTable: string;
  errorMessage: string;
  startedBy: string;
}

export interface IDocumentMigrationStatus {
  latestJob: IDocumentMigrationJob;
  pendingCopyCount: number;
  isRunning: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  private readonly api: string = environment.privateApi;

  constructor(private readonly http: HttpClient) {}

  startDocumentMigration(phase: DocumentMigrationPhase): Observable<IDocumentMigrationJob> {
    return this.http.post<IDocumentMigrationJob>(`${this.api}Admin/DocumentMigration/Start?phase=${phase}`, null, httpOptions);
  }

  getDocumentMigrationStatus(): Observable<IDocumentMigrationStatus> {
    return this.http.get<IDocumentMigrationStatus>(`${this.api}Admin/DocumentMigration/Status`, httpOptions);
  }

  getDocumentMigrationHistory(take: number = 10): Observable<IDocumentMigrationJob[]> {
    return this.http.get<IDocumentMigrationJob[]>(`${this.api}Admin/DocumentMigration/History?take=${take}`, httpOptions);
  }

  cancelDocumentMigration(): Observable<boolean> {
    return this.http.post<boolean>(`${this.api}Admin/DocumentMigration/Cancel`, null, httpOptions);
  }

  downloadFailureReport(jobId: number): Observable<Blob> {
    return this.http.get(`${this.api}Admin/DocumentMigration/FailureReport/${jobId}`, {
      responseType: 'blob',
      withCredentials: true
    });
  }
}
